import { colors } from '../../theme/colors';
import { fontSize, fontWeight, lineHeight } from '../../theme/typography';

/**
 * Shared field-label type for Create Request / Request view.
 * Edit (`FormInput`, `TextArea`) and view (`ViewOnlyFieldValue`) must use this
 * so label chrome does not fork by mode.
 */
export const formFieldLabelText = {
  fontSize: fontSize.formLabel,
  lineHeight: lineHeight.formLabel,
  fontWeight: fontWeight.medium,
  color: colors.textPrimary,
} as const;
